<template>
  <div class="display">
    <div class="base-info">
      <p class="display-title">基本信息</p>
      <div class="display-middle">
        <icon-unit titleKey="机构名称" :titleValue="hospitalTitle" iconKey="机构Logo" :iconURL="hospitalLogo"></icon-unit>
      </div>
      <div class="display-row" v-if="isSeniorAdministrator">
        <div class="display-row-key">机构全称：</div>
        <div class="display-row-value">{{ hospitalFullName }}</div>
      </div>
      <div class="display-row" v-if="isSeniorAdministrator">
        <div class="display-row-key">机构所在地区：</div>
        <div class="display-row-value">{{ hospitalAddress }}</div>
      </div>
      <div class="display-row" v-if="isSeniorAdministrator">
        <div class="display-row-key">机构等级：</div>
        <div class="display-row-value">{{ hospitalLevel }}</div>
      </div>
      <div class="display-row" v-if="isSeniorAdministrator">
        <div class="display-row-key">科室：</div>
        <div class="display-row-value">{{ hospitalDepartment }}</div>
      </div>
      <div class="display-row" v-if="isSeniorAdministrator">
        <div class="display-row-key">账号性质：</div>
        <div class="display-row-value">{{ accountNature }}</div>
      </div>
    </div>
    <!-- <div class="patient-id">
      <p class="display-title">病案号配置</p>
      <div class="display-middle">
        <pid-unit :isPatientIdRequired="isPatientIdRequired" :isPatientIdDisplay="isPatientIdDisplay"></pid-unit>
      </div>
    </div> -->
  </div>
</template>

<script>
import IconUnit from "@c/setting/organization-configuration/display/icon-unit.vue";
import InfoUnit from "@c/setting/organization-configuration/display/info-unit/info-unit.vue";
import PidUnit from "@c/setting/organization-configuration/display/pid-unit.vue";

export default {
  components: {
    IconUnit,
    InfoUnit,
    PidUnit
  },

  props: {
    model: Object,
  },

  computed: {
    hospitalTitle() {
      return this.model.hospitalName;
    },

    hospitalLogo() {
      if (this.model.hospitalLogo == undefined) {
        return require("@imgs/logo-placeholder.png");
      } else {
        return this.model.hospitalLogo;
      }
    },

    reportTitle() {
      return this.model.reportTitle;
    },
    reportSubtitle(){
      return this.model.reportSubtitle;
    },

    reportLogo() {
      if (this.model.reportLogo == undefined) {
        return require("@imgs/logo-placeholder.png");
      } else {
        return this.model.reportLogo;
      }
    },

    standardTitle() {
      return findKey(CHILD_STANDDARD_TYPE_CODE, this.model.reportStandard);
    },

    suggestionTitle() {
      return findKey(REPORT_SUGGESTION_TYPE, this.model.reportEvaluate);
    },
    isPatientIdRequired() { 
      return false
    },
    isPatientIdDisplay() {
      return this.model.pollShowCaseNumber === '1' ? true : false;
    },
    hospitalFullName() {
      if (!this.model.fullName) {return '-'}
      return this.model.fullName;
    },
    hospitalAddress() {
      if (!this.model.province) {return '-'}
      return this.model.province + ' ' + (this.model.city || "") + ' ' + (this.model.district || "");
    },
    hospitalLevel() {
      if (!this.model.levelName) {return '-'}
      return this.model.levelName;
    },
    hospitalDepartment() {
      if (!this.model.departmentName) {return '-'}
      return this.model.departmentName;
    },
    accountNature() {
      if (!this.model.natureName) {return '-'}
      return this.model.natureName;
    },

    isSeniorAdministrator() {
      return this.$store.getters.isSeniorAdministrator;
    }
  },
};
</script>

<style lang="scss" scoped>

.display {
  background-color: white;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;

  .base-info {
    
  }
  .patient-id {
    width: 400px;
  }

  &-title {
    color: black;
    font-size: rem(16);
    font-weight: bold;
    height: rem(22);
    margin-top: rem(16);
  }

  &-middle {
    margin-top: rem(18);
    display: flex;

    &-right {
      position: absolute;
      left: rem(618);
    }
  }
  &-row {
    display: flex;
    margin-top: rem(16);
    &-key {
      width: rem(120);
      font-size: rem(14);
    }
    &-value {
      flex: 1;
      font-size: rem(14);
    }
  }


}
</style>